import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Exoticcabbookinginkolkata() {



  const cardData =
  {
    keyword: 'Exotic Cab Bookings in Kolkata',
    heading: 'Aaryan Travels: Exotic Cab Bookings in Kolkata',
    headingDescription: 'Aaryan Travels offers premium Exotic Cab Bookings in Kolkata for weddings, celebrity events, corporate travel, and luxury rides across the city. Whether you need a high-end sedan like Mercedes or BMW, a luxury SUV, or a premium chauffeur-driven vehicle for special occasions, our fleet ensures elegance and exclusivity. With professional drivers, plush interiors, and on-request amenities like Wi-Fi and bottled water, we deliver a superior travel experience across Salt Lake, New Town, Park Street, and Howrah. For those who want to arrive in style, Aaryan Travels is the trusted choice for exotic cab bookings in Kolkata.',

    top: 'Top Places to Visit in Kolkata with Aaryan Travels',

"topPlaces": [
  {
    "title": "Victoria Memorial",
    "description": "Victoria Memorial, built in memory of Queen Victoria, is one of Kolkata’s most iconic landmarks. Made of white Makrana marble, it blends British and Mughal architectural styles. The surrounding gardens offer peaceful walks and picturesque views. Inside, the museum displays artifacts from the British era. Illuminated beautifully at night, Victoria Memorial is Kolkata’s regal symbol of history and elegance."
  },
  {
    "title": "Howrah Bridge (Rabindra Setu)",
    "description": "Howrah Bridge, officially known as Rabindra Setu, is an engineering marvel spanning the Hooghly River without any nuts or bolts. Serving millions of commuters daily, it stands as a lifeline of the city. The view of the river and bustling ghats beneath is captivating. Lit up at night, the bridge looks majestic. Howrah Bridge is Kolkata’s iconic gateway of connectivity and pride."
  },
  {
    "title": "Dakshineswar Kali Temple",
    "description": "Dakshineswar Kali Temple, built in 1855 by Rani Rashmoni, is a renowned pilgrimage site dedicated to Goddess Kali. Located on the banks of the Hooghly River, it features traditional Bengali architecture with nine spires. Sri Ramakrishna Paramahamsa served as its chief priest. Devotees find deep spiritual peace here. Dakshineswar is Kolkata’s sacred abode of devotion."
  },
  {
    "title": "Belur Math",
    "description": "Belur Math is the global headquarters of the Ramakrishna Mission, founded by Swami Vivekananda. Its unique architecture blends Hindu, Islamic, and Christian designs, symbolizing unity of all religions. The serene campus by the Hooghly River offers meditation and peaceful reflection. Evening aarti is especially soul-stirring. Belur Math is Kolkata’s spiritual center of harmony."
  },
  {
    "title": "Park Street",
    "description": "Park Street is Kolkata’s entertainment hub lined with cafes, restaurants, pubs, and colonial-era buildings. Known for its vibrant nightlife and Christmas celebrations, it remains lively day and night. Iconic eateries like Flurys and Peter Cat add vintage flavor. Live music and street lights create an enchanting vibe. Park Street is Kolkata’s heartbeat of food and festivity."
  },
  {
    "title": "Indian Museum",
    "description": "Established in 1814, the Indian Museum in Kolkata is the oldest and largest museum in India. It houses rare collections of fossils, Mughal paintings, Egyptian mummies, and Buddhist relics. Each gallery reveals centuries of heritage and knowledge. History enthusiasts can spend hours exploring its vast exhibits. The Indian Museum is Kolkata’s grand archive of civilization."
  },
  {
    "title": "Science City",
    "description": "Science City is one of Asia’s largest science centers offering interactive exhibits, space theaters, and robotics shows. The Evolution Park, Time Machine, and Mirror Maze attract both children and adults. It makes learning exciting and engaging. The outdoor musical fountain show adds to the experience. Science City is Kolkata’s futuristic world of curiosity and fun."
  },
  {
    "title": "St. Paul’s Cathedral",
    "description": "St. Paul’s Cathedral, built in 1847, is a stunning example of Indo-Gothic architecture. Its stained glass windows, tall spires, and peaceful interiors create a sacred ambiance. The church hosts carol services and Christmas masses that attract large crowds. Surrounded by greenery, it offers quiet reflection. St. Paul’s Cathedral is Kolkata’s elegant landmark of faith."
  },
  {
    "title": "Kalighat Temple",
    "description": "Kalighat Temple is one of the 51 Shakti Peethas dedicated to Goddess Kali. The temple’s deity is worshipped in fierce form, attracting thousands of devotees daily. Despite heavy crowds, the divine energy is powerful. Rituals and chants maintain a timeless spiritual aura. Kalighat is Kolkata’s ancient seat of devotion and strength."
  },
  {
    "title": "Eco Park",
    "description": "Eco Park is Kolkata’s largest urban park featuring themed gardens, water sports, cycling tracks, and a replica of the Seven Wonders of the World. The vast greenery and lakes make it ideal for picnics and evening strolls. Families and couples enjoy boating and recreational activities. Eco Park is Kolkata’s refreshing escape into nature and leisure."
  }
],



"services": [
  {
    "name": "Exotic Cab Bookings in Kolkata",
    "description": "Exotic Cab Bookings in Kolkata provide access to a fleet of rare and luxury vehicles, perfect for those seeking a unique and lavish travel experience. Ideal for special occasions, business events, or leisure rides, this service ensures the highest standards of comfort, style, and exclusivity with professional chauffeurs."
  },
  {
    "name": "Exotic Car Rentals Kolkata",
    "description": "Exotic Car Rentals Kolkata offer an impressive collection of high-performance and luxury cars for rent. Whether for weddings, corporate events, or personal indulgence, customers enjoy top-tier vehicles with expert maintenance and chauffeur support for a flawless ride."
  },
  {
    "name": "Premium Cab Hire Kolkata",
    "description": "Premium Cab Hire Kolkata delivers luxurious vehicles and attentive chauffeur services tailored to meet the demands of discerning clients. Perfect for business travel, VIP transfers, or upscale social events, this service emphasizes punctuality, discretion, and comfort."
  },
  {
    "name": "Chauffeur Exotic Cab Kolkata",
    "description": "Chauffeur Exotic Cab Kolkata offers professional drivers trained in luxury service etiquette, ensuring every ride is smooth, safe, and memorable. The chauffeurs are familiar with Kolkata’s best routes and provide personalized assistance for an elevated travel experience."
  },
  {
    "name": "Luxury Exotic Taxi Kolkata",
    "description": "Luxury Exotic Taxi Kolkata provides elegant and rare vehicles for hire, combining luxury with convenience. This service is designed to impress clients and guests who expect the utmost quality and style in their transportation."
  },
  {
    "name": "Sports Car Hire Kolkata",
    "description": "Sports Car Hire Kolkata lets you experience the thrill of driving or being chauffeured in high-performance sports cars. Perfect for adrenaline seekers, special events, and luxury travel, this service offers well-maintained vehicles and flexible rental options."
  },
  {
    "name": "High-End Vehicle Booking Kolkata",
    "description": "High-End Vehicle Booking Kolkata caters to clients looking for exclusive luxury vehicles for any occasion. With a variety of sedans, SUVs, and exotic cars, this service ensures availability, prompt booking, and exceptional customer service."
  },
  {
    "name": "Classic Car Rental Kolkata",
    "description": "Classic Car Rental Kolkata provides vintage and timeless automobiles for events that require a touch of nostalgia and elegance. These vehicles are meticulously maintained and perfect for weddings, photo shoots, and premium events."
  },
  {
    "name": "Luxury Car Booking Kolkata",
    "description": "Luxury Car Booking Kolkata offers an extensive range of premium vehicles available for short and long-term rentals. The service focuses on ease of booking, reliability, and delivering a comfortable, stylish travel experience."
  },
  {
    "name": "Wedding Exotic Cab Kolkata",
    "description": "Wedding Exotic Cab Kolkata specializes in luxury exotic vehicles tailored for wedding ceremonies, guest transport, and bridal party rides. These high-end cars add glamour and sophistication to any wedding event, complemented by professional chauffeurs."
  },
  {
    "name": "Best Exotic Cabs Kolkata",
    "description": "Best Exotic Cabs Kolkata is known for its exceptional fleet and top-notch service quality. Clients can expect punctual pickups, elegant vehicles, and experienced drivers who understand the nuances of luxury transportation."
  },
  {
    "name": "Affordable Exotic Taxi Kolkata",
    "description": "Affordable Exotic Taxi Kolkata combines luxury with budget-conscious pricing, making exotic car experiences accessible without compromising on comfort or style. Ideal for customers seeking value alongside premium services."
  },
  {
    "name": "Kolkata Elite Car Rentals",
    "description": "Kolkata Elite Car Rentals offers exclusive access to a curated selection of elite vehicles, including exotic and luxury models. This service prioritizes personalized experiences and premium client care for every booking."
  },
  {
    "name": "VIP Cab Hire Kolkata",
    "description": "VIP Cab Hire Kolkata provides high-end cabs with luxurious interiors and professional chauffeurs, perfect for executives, celebrities, and VIP guests. The service emphasizes discretion, punctuality, and exceptional comfort."
  },
  {
    "name": "Online Exotic Cab Booking Kolkata",
    "description": "Online Exotic Cab Booking Kolkata simplifies the reservation process with a user-friendly digital platform, allowing clients to select vehicles, schedule rides, and manage bookings conveniently. The service ensures quick confirmations and reliable luxury transport."
  }
],
"tableData": [
  ["Exotic Cab Bookings in Kolkata", "Exotic Car Rentals Kolkata"],
  ["Premium Cab Hire Kolkata", "Chauffeur Exotic Cab Kolkata"],
  ["Luxury Exotic Taxi Kolkata", "Sports Car Hire Kolkata"],
  ["High-End Vehicle Booking Kolkata", "Classic Car Rental Kolkata"],
  ["Luxury Car Booking Kolkata", "Wedding Exotic Cab Kolkata"],
  ["Best Exotic Cabs Kolkata", "Affordable Exotic Taxi Kolkata"],
  ["Kolkata Elite Car Rentals", "VIP Cab Hire Kolkata"],
  ["Online Exotic Cab Booking Kolkata", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Exotic Cab Bookings in Kolkata",
    "WhyChoosedescription": "Aaryan Travels offers exclusive exotic cab bookings in Kolkata, perfect for luxury travel, special occasions, and making a grand entrance."
  },
  {
    "WhyChooseheading": "Fleet of Exotic and High-End Vehicles",
    "WhyChoosedescription": "Choose from our collection of rare and premium cars that deliver unmatched style and performance."
  },
  {
    "WhyChooseheading": "Professional Chauffeurs with Discretion",
    "WhyChoosedescription": "Our experienced drivers provide punctual, courteous, and discreet service for a VIP travel experience."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Cabs",
    "WhyChoosedescription": "All exotic vehicles are regularly cleaned and maintained to ensure comfort, hygiene, and safety."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Benefit from all-inclusive rates covering fuel, tolls, and driver allowances, with no surprise fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Select from hourly, daily, or customized plans tailored to your exotic cab rental needs."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service in Kolkata",
    "WhyChoosedescription": "We ensure timely pickups and drop-offs, providing a smooth and luxurious travel experience."
  }
]














  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer exotic cab bookings in Kolkata?',
    answer: 'Yes, Aaryan Travels provides exclusive exotic cab bookings in Kolkata featuring rare and luxurious vehicles for a unique travel experience.',
  },
  {
    question: 'How can I book exotic cab services in Kolkata with Aaryan Travels?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer support team in Kolkata.',
  },
  {
    question: 'What types of exotic vehicles are available for booking in Kolkata?',
    answer: 'Aaryan Travels offers a selection of exotic cars including Lamborghinis, Ferraris, Bentleys, and other luxury sports cars in Kolkata.',
  },
  {
    question: 'Are drivers trained to handle exotic cabs in Kolkata?',
    answer: 'Absolutely. Our drivers are experienced, licensed, and trained to provide a safe, smooth, and premium ride in exotic vehicles.',
  },
  {
    question: 'Can exotic cab bookings be customized for special occasions or corporate use in Kolkata?',
    answer: 'Yes, you can book exotic cabs for weddings, corporate events, parties, or any special occasion in Kolkata.',
  },
  {
    question: 'Is the exotic cab booking service available 24x7 in Kolkata?',
    answer: 'Yes, Aaryan Travels offers round-the-clock exotic cab booking services to meet your schedule in Kolkata.',
  },
  {
    question: 'Are safety and hygiene protocols followed for exotic cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene standards.',
  },
  {
    question: 'What payment options are accepted for exotic cab bookings in Kolkata?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts.',
  },
  {
    question: 'Is customer support available during the exotic cab booking period in Kolkata?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your exotic cab booking.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anirban Sen',
    feedback: 'Aaryan Travels provided an unforgettable exotic cab experience in Kolkata with their luxury sports cars and professional drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Nandita Mukherjee',
    feedback: 'Highly recommend Aaryan Travels for exotic cab bookings in Kolkata. Exceptional cars and outstanding service.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const exoticCabKolkataSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Exotic Cab Bookings in Kolkata",
  "description": "Aaryan Travels provides exotic cab bookings in Kolkata, including premium and luxury exotic car rentals, chauffeur-driven sports cars, and elite vehicle hire for weddings and events.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Kolkata"
  },
  "serviceType": "Exotic Car Rental Service",
  "keywords": "Exotic Cab Bookings in Kolkata, Exotic Car Rentals Kolkata, Premium Cab Hire Kolkata, Chauffeur Exotic Cab Kolkata, Luxury Exotic Taxi Kolkata, Sports Car Hire Kolkata, High-End Vehicle Booking Kolkata, Classic Car Rental Kolkata, Luxury Car Booking Kolkata, Wedding Exotic Cab Kolkata, Best Exotic Cabs Kolkata, Affordable Exotic Taxi Kolkata, Kolkata Elite Car Rentals, VIP Cab Hire Kolkata, Online Exotic Cab Booking Kolkata"
};



  return (
    <div>

<Helmet>
  <title>Exotic Cab Bookings in Kolkata | Luxury & Sports Car Rentals | Aaryan Travels</title>
  <meta
    name="description"
    content="Book exotic cab rentals in Kolkata with Aaryan Travels. Premium luxury cars, sports cars, and chauffeur-driven exotic taxis available for weddings, events, and VIP transport."
  />
  <meta
    name="keywords"
    content="Exotic Cab Bookings in Kolkata, Exotic Car Rentals Kolkata, Premium Cab Hire Kolkata, Chauffeur Exotic Cab Kolkata, Luxury Exotic Taxi Kolkata, Sports Car Hire Kolkata, High-End Vehicle Booking Kolkata, Classic Car Rental Kolkata, Luxury Car Booking Kolkata, Wedding Exotic Cab Kolkata, Best Exotic Cabs Kolkata, Affordable Exotic Taxi Kolkata, Kolkata Elite Car Rentals, VIP Cab Hire Kolkata, Online Exotic Cab Booking Kolkata"
  />
  <script type="application/ld+json">
    {JSON.stringify(exoticCabKolkataSchema)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/99.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Exoticcabbookinginkolkata;